// REA-CI/screens/EligibilityScreen.tsx

import React from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";
import { useNavigation } from "@react-navigation/native";
import { RootStackParamList, StackNavigationProp } from "../navigation/types";

type EligibilityScreenNavigationProp = StackNavigationProp<
  RootStackParamList,
  "EligibilityScreen"
>;

const EligibilityScreen = () => {
  const navigation = useNavigation<EligibilityScreenNavigationProp>();

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Are you a Buyer or Seller?</Text>

      <TouchableOpacity
        style={styles.button}
        onPress={() => navigation.navigate("BuyerHomeScreen")} // Replace with your main page route
      >
        <Text style={styles.buttonText}>Buyer</Text>
      </TouchableOpacity>

      <TouchableOpacity
        style={styles.button}
        onPress={() => navigation.navigate("VerificationScreen")}
      >
        <Text style={styles.buttonText}>Seller</Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#ffffff",
    padding: 20,
  },
  title: {
    fontSize: 24,
    fontWeight: "bold",
    marginBottom: 20,
    textAlign: "center",
  },
  button: {
    backgroundColor: "#007BFF",
    paddingVertical: 15,
    paddingHorizontal: 30,
    borderRadius: 5,
    marginVertical: 10,
  },
  buttonText: {
    color: "#ffffff",
    fontSize: 16,
    fontWeight: "bold",
  },
});

export default EligibilityScreen;